import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function Callback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // The AuthProvider should have already processed the OIDC callback
    // by the time this component's useEffect runs.
    // It exchanges the code for tokens and updates the auth state.
    // The library also typically cleans the code/state from the URL.

    if (auth.isAuthenticated) {
      // Instead of navigating to the original intended path (returnUrl),
      // always navigate to the desired post-login page, which is /prompt.
      const returnUrl = '/'; // Hardcode the desired redirect path

      //console.log('Callback: Authenticated, navigating to:', returnUrl);
      navigate(returnUrl, { replace: true });
    } else if (!auth.isLoading && auth.error) {
      // Handle cases where token exchange might have failed after redirect
      console.error('Callback: Authentication error after redirect:', auth.error);
      navigate('/login', { replace: true, state: { error: auth.error.message } });
    }
    // If still loading, or not authenticated and no error, wait for auth state to change.
  }, [auth.isAuthenticated, auth.isLoading, auth.user, auth.error, navigate]);

  return (
    <Stack sx={{ height: "100%", justifyContent: "center", alignItems: "center" }}><Typography>Processing login...</Typography></Stack>
  );
}

export default Callback;